import axios from 'axios';
const backEndUrl = process.env.REACT_APP_API_ENDPOINT;
const makeBackendUrl = process.env.REACT_APP_MAKEAPI_ENDPOINT;
export const getPresignedUrlForFile = async (bucketName, bucketKey) => {
    try {
        const response = await axios.get(`${backEndUrl}/s3/get-presigned-url`, {
            params: {
                bucketName,
                objectKey: bucketKey,
            },
        });

        return response.data.signedUrl;
    } catch (error) {
        console.error("Error fetching pre-signed URL:", error);
        throw new Error("Failed to fetch pre-signed URL");
    }
};

export const getAllMaterialsList = async () => {
    try {
        const response = await axios.get(`${makeBackendUrl}/api/v2/common/masters/materials-list`);
        return response.data;
    } catch (error) {
        console.error("Error fetching materials:", error);
        throw new Error("Failed to fetch materials");
    }
}


export const getAllTechnology = async () => {
    try {
        const response = await axios.get(`${makeBackendUrl}/admin/get-3dtechnology`);
        return response.data;
    } catch (error) {
        return false;
    }
};